<template>
  <BCard class="container">
    <div class="d-flex">
      <BButton
        variant="primary"
        size="sm"
        class="rounded-lg mr-2"
        @click="$router.back()"
      >
        <b-icon-chevron-left />
      </BButton>
      <span class="text-[24px] font-semibold my-auto text-black">Notification Bar</span>
    </div>
    <BTabs
      class="mt-2"
      content-class="mt-2"
    >
      <BTab
        title="Message"
        :active="type === 'message'"
        lazy
        title-item-class="w-[200px] rounded-[25px]"
        @click="handleChangeType('message')"
      >
        <Messages />
      </BTab>
      <BTab
        title="Banner"
        :active="type === 'banner'"
        lazy
        title-item-class="w-[200px] rounded-[25px]"
        @click="handleChangeType('banner')"
      >
        <Banner />
      </BTab>
    </BTabs>
  </BCard>
</template>
<script>
import Messages from './components/Messages.vue'
import Banner from './components/Banner.vue'

export default {
  components: {
    Messages,
    Banner,
  },
  data() {
    return {
      type: this.$route.query.type,
    }
  },
  methods: {
    handleChangeType(type) {
      this.type = type
    },
  },
}
</script>
